module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'customers',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            // colWidth: '105px',
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                // {
                //     buttonType: 'delete',
                //     neutral: true,
                // }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_customers': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'customerID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_customers:create', }
                ]
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'customers':
                    if(insertPerformed && entityID && entityData){
                        this.showEdit(entityID, entityData)
                    }
            }
        },
    }
}